module.exports = __webpack_public_path__ + "media/images/btn_google_dark_normal_ios-d5daa8d1dcab8f996fbe8005dded051c.svg";